import React from "react";
import "../../styles/registration.css";
import banner from "../../assets/Asset-025.png"

import { useNavigate } from "react-router-dom";

const Banner = () => {
    const navigate = useNavigate();
  return (
    <section className="banner-section p-3">
      {/* The main card container */}
      <div className="banner-card">
        
        {/* LEFT SIDE: Content */}
        <div className="banner-content">
          
          {/* Top Description Text */}
          <p className="banner-top-text">
         <strong>Practical training in ERP, Computers, and English  <br className="d-none d-md-block" />
          to make you job-ready and future-ready. </strong>
          </p>
          
          {/* Main Headline with Orange Background */}
          <h2 className="banner-title">
            <span className="highlight-orange">Skills That Shape Careers</span>
            
          </h2>

          <button className="register-btn"onClick={() => navigate("/contact")}>Register Now</button>
        </div>

        {/* RIGHT SIDE: Image */}
        <div className="banner-image-container">
          <img
            src={banner}
            alt="Global Professionals"
            className="banner-img"
          />
        </div>
        
      </div>
    </section>
  );
};

export default Banner;